<template>
  <div class>
    <drawer
      :title="addEditTitle"
      :dialogShow="addEditShow"
      @handleChange="back"
    >
      <div slot="body">
        <div class="pay-mains">
          <div class="member-msg">
            <div class="member-border">
              <el-avatar
                class="img"
                shape="circle"
                v-if="form.memberId && memberList.headImgUrl"
                :src="memberList.headImgUrl"
              ></el-avatar>
              <el-avatar shape="circle" v-else :src="headerImg"></el-avatar>
              <div class="rows no-member">
                <p class="member-box">{{ shopName }}</p>
              </div>
            </div>
          </div>
          <p class="order-title-boxs mtb24">
            <span class="blueBlock"></span><i>消费清单</i>
          </p>
          <div class="totals-box plr16">
            <el-row class="order-details">
              <el-col :span="10" class="pl10">商品名称</el-col>
              <el-col :span="3" class="divCenter">单价(元)</el-col>
              <el-col :span="3" class="divCenter">数量</el-col>
              <el-col :span="4" class="divCenter">优惠(元)</el-col>
              <el-col :span="4" class="tRight pr10">小计(元)</el-col>
            </el-row>
            <div class="order-scoll">
              <!-- 准备做滑动 -->
              <el-row class="mt20 order-good-detail">
                <el-col :span="10" class="pl10">{{ form.name }}</el-col>
                <el-col :span="3" class="color999 divCenter">{{
                  form.salePrice
                }}</el-col>
                <el-col :span="3" class="color999 divCenter">{{
                  form.itemNum
                }}</el-col>
                <el-col :span="4" class="color999 divCenter">{{
                  form.faceValue
                }}</el-col>
                <el-col :span="4" class="tRight pr10">{{
                  form.itemNum * form.salePrice
                }}</el-col>
              </el-row>
            </div>
          </div>
          <el-row class="orderTotal borderT fontSize18">
            <el-col :span="12" class="flex-row pb24">
              <p class="label">消费数量：</p>
              <p class="num">{{ form.itemNum }}</p>
            </el-col>
            <el-col :span="12" class="flex-row pb24">
              <p class="label">合计金额：</p>
              <p class="money num" v-if="form.orderType == 'shopManage'">￥{{ form.salePrice }}</p>
              <p class="money num" v-else>￥{{ form.itemNum * form.salePrice }}</p>
            </el-col>
            <el-col :span="12" class="flex-row pb24">
              <p class="label">折扣优惠：</p>
              <span class="num moneys">￥{{ form.faceValue }}</span>
            </el-col>

            <el-col :span="12" class="flex-row">
              <p class="label">支付金额：</p>
              <span class="moneys num fontSize20" v-if="form.orderType == 'shopManage'"
                      >￥<span class="fontSize20 fb">{{
                        (form.faceValue
                          ? form.salePrice -
                          form.faceValue
                          : form.salePrice
                        ).toFixed(2)
                      }}</span></span
                    >
                    <span class="moneys num fontSize20" v-else
                      >￥<span class="fontSize20 fb">{{
                        (
                          (form.salePrice * form.itemNum) - form.faceValue
                        ).toFixed(2)
                      }}</span></span
                    >

            </el-col>
          </el-row>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <el-button class="right-btn" @click="confirmMoney" v-if="form.orderType == 'shopManage'">
              立即支付￥{{(form.salePrice - form.faceValue).toFixed(2)}}
              </el-button>
              <el-button class="right-btn" @click="confirmMoney" v-else>
              立即支付￥{{
                        (
                          (form.salePrice * form.itemNum) - form.faceValue
                        ).toFixed(2)
                      }}
              </el-button>
          </div>
        </div>
      </div>
    </drawer>
    <pay ref="payForm" @change="backChange"></pay>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
import pay from "./pay.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    pay,
  },
  data() {
    return {
      radio: "WECHAT",
      addEditShow: false,
      addEditTitle: "订购服务",
      shopInfo: this.$store.getters.ShopInfo,
      shopName: '',
      form: {
        orderId: "",
        payWay: "WECHAT",
        payCheckType: "",
        couponSendRecordId: "",
      },
      headerImg: require("../../../assets/images/headerImg.png"),
      parentForm: {
        memberId: "",
        realPayAmount: 0,
        couponAmount: 0,
      },
      isPay: false,
      memberList: {},
      isSelectCoupon: false,
      couponSendRecordId: "",
      couponAmount: 0,
      balance: "",
    };
  },
  created() {
    this.init();
    let msg = JSON.parse(localStorage.getItem("shopInfo"))
    this.shopName = msg.selectShopName;
    console.log('门店信息：',msg);
  },
  methods: {
    back() {
      this.addEditShow = false;
        this.isSelectCoupon = false;
        this.couponSendRecordId = "";
        this.parentForm.couponAmount = 0;
        this.couponAmount = 0;
        this.form.couponSendRecordId = "";
    },
    init() {
      this.$on("set", function(org) {
        this.addEditShow = true;
        this.form = org;
      });
    },
    payWayFun(item) {
      console.log('支付方式:',item);
      this.form.payWay = item;
      this.radio = item;
    },
    backChange(org) {
      if (org) {
        console.log(org);
        this.form = {
          orderId: "",
          payWay: "",
          payCheckType: "",
          couponSendRecordId: "",
        };
        this.parentForm = {
          memberId: "",
          realPayAmount: 0,
          couponAmount: 0,
        };
        this.orderId = "";
        this.isPay = false;
        this.$emit("change", true);
        this.addEditShow = false;
        this.isSelectCoupon = false;
        this.couponSendRecordId = "";
      }
    },
    //收款
    confirmMoney() {
      let url = "";
      let realPayAmount = 0;
      if (this.form.orderType == "shopManage") {
        realPayAmount = (this.form.salePrice - this.form.faceValue).toFixed(2);
      } else {
        realPayAmount = (this.form.salePrice * this.form.itemNum).toFixed(2);
      }
      let params = {
        orderId: this.form.orderId,
        itemId: this.form.itemId,
        itemType: this.form.itemType,
        itemNum: this.form.itemNum,
        payWay: '',
        payPlatform: this.form.payPlatform,
        couponCode: this.form.couponCode,
        couponPwd: this.form.couponPwd,
        source: this.form.source,
      }
      this.$api.post(this.$url.shopServe.createAllPackage, encrypt(JSON.stringify(params))).then((res) => {
        if (res) window.open(res.payUrl,'_self')
        return
        if (res) {
          let parmar = {
            url: res.payUrl,
            realPayAmount: realPayAmount,
            orderId: res.orderId,
            itemId: this.form.itemId,
            itemNum: this.form.itemNum,
            payWay: this.form.payWay,
            payStatus: res.payStatus,
            source: this.form.source,
          };
          this.$refs["payForm"].$emit("set", parmar);
        }
      });
    },
  },
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .order-details {
    height: 56px;
    line-height: 56px;
    background: #f7f8fa;
  }
  .member-msg {
    padding: 16px 16px 0;
    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: url("../../../assets/images/new/memberSearch.png") no-repeat;
      background-position: right center;
      box-sizing: border-box;
      .member-box {
        margin-left: 10px;
        .mobile {
          line-height: 1.6;
          margin-right: 46px;
        }
      }
    }
  }
  .titles {
    height: 48px;
    font-weight: 500;
    font-size: 18px;
    padding-left: 26px;
    border-bottom: 2px solid @borderColor;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .pay-methods {
    border-top: 10px solid #f5f5f5;
    margin-top: 20px;
    .orderPayRadio {
      width: 100% / 3.5;
      height: 56px;
      background: #ffffff;
      border: 1px solid #dcdee0;
      border-radius: 4px;
      align-items: center;
      padding-left: 16px;
      cursor: pointer;
      position: relative;
      margin-right: 2%;
      &:last-child {
        margin-right: 0 !important;
      }
      .payCheak {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .pay-img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .active {
      color: #3388ff;
      border: 1px solid #3388ff;
      background: #eaf4fe;
    }
  }
}
.btns {
  width: 100%;
  display: flex;
  padding: 10px 24px 10px;
  border-top: 1px solid #eee;
  .left-btn {
    width: 176px;
    height: 56px;
    color: #fff;
    font-size: 20px;
    background: #535a6c;
    border-radius: 4px;
  }
  .right-btn {
    flex: 1;
    width: 100%;
    color: #fff;
    font-size: 20px;
    height: 56px;
    background: #ff5449;
    border-radius: 4px;
  }
}
.order-scoll {
  height: calc(100vh - 670px);
  overflow-y: auto;
  .order-good-detail {
    padding-bottom: 20px;
    border-bottom: 1px solid #ebedf0;
  }
}
.orderTotal {
  padding: 23px 25px 0;
}
</style>
